import React from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { withTheme } from '@shared/lib';
import { ICON_TCP } from '@shared/config';
interface Props {
  type?: 'button' | 'submit' | 'reset';
  isActive?: boolean;
  title: string;
  onClick?: () => void;
  icon?: string;
  tooltip?: React.ReactElement;
  // discount?: string
}
export const OldButton = ({
  type = 'button',
  isActive,
  title,
  onClick,
  icon,
  tooltip
}: Props) => {
  // const router = useRouter()
  // const { id } = router.query

  const handleButtonClick = event => {
    event.stopPropagation();
    if (!isActive) {
      onClick?.();
    }
  };
  return <Wrapper isActive={isActive} onClick={handleButtonClick} type={type}
  // disabled={title !== 'Страны СНГ' && isActive}
  >
      {title === 'США и Европа' ? <>
          <WrapperIcon>
            <Image src={`${ICON_TCP}USA_04032024.svg`} alt="icon" height={24} width={24} />
            <div style={{
          display: 'flex',
          position: 'absolute',
          right: '-20px',
          top: '-2px',
          zIndex: '5'
        }}>
              <Image src={`${ICON_TCP}European_Union_04032024.svg`} alt="icon" height={28} width={28} />
            </div>
          </WrapperIcon>
          <Text isActive={isActive}>{title}</Text>
        </> : <>
          {icon && <Image src={`${ICON_TCP}${icon}`} alt="icon" height={24} width={24} style={{
        borderRadius: '8px'
      }} />}
          <Text isActive={isActive}>{title}</Text>
          {tooltip && <>{tooltip}</>}
          {/* {discount && title === 'Турция' && id === 'playstation-network' && <Discount title={discount} />} */}
        </>}
    </Wrapper>;
};
interface TextProps {
  isActive?: boolean;
}
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp4 = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.text.white : theme.colors.text.tertiary;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const StyledText = /*#__PURE__*/styled('div')({
  name: "StyledText",
  class: "swqggdn",
  propsAsIs: false,
  vars: {
    "swqggdn-0": [_exp()],
    "swqggdn-1": [_exp2(), "px"],
    "swqggdn-2": [_exp3()],
    "swqggdn-3": [_exp4()],
    "swqggdn-4": [_exp5(), "px"]
  }
});
const Text = withTheme(StyledText);
interface WrapperProps {
  isActive?: boolean;
}
const _exp6 = /*#__PURE__*/() => ({
  isActive,
  theme
}) => isActive ? theme.colors.state.active : theme.colors.bg.tertiary;
const _exp8 = /*#__PURE__*/() => ({
  isActive,
  theme
}) => !isActive ? theme.colors.text.primary : theme.colors.text.white;
const Wrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "Wrapper",
  class: "w17e9v6z",
  propsAsIs: false,
  vars: {
    "w17e9v6z-0": [_exp6()],
    "w17e9v6z-1": [_exp8()]
  }
}));
const WrapperIcon = /*#__PURE__*/styled('div')({
  name: "WrapperIcon",
  class: "w1xww7ha",
  propsAsIs: false
});

require("./OldButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./OldButton.tsx");